"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("./types");
const generateValidator_1 = __importStar(require("../commonApp/generateValidator"));
const validateQuestionAnswer = (question, answer) => {
    const { type, choices, validators = [], } = question;
    switch (type) {
        case types_1.QuestionType.RADIO: {
            return (choices || []).find(({ value }) => value === answer)
                ? undefined
                : 'Please select a choice';
        }
        case types_1.QuestionType.NUMBER: return (0, generateValidator_1.default)([
            { type: generateValidator_1.ValidatorType.required },
            { type: generateValidator_1.ValidatorType.number },
            ...validators,
        ])(answer);
        case types_1.QuestionType.STATE_GEOLOC: return ((answer === null || answer === void 0 ? void 0 : answer.state) ? undefined : 'Please select a location');
        default: return undefined;
    }
};
exports.default = validateQuestionAnswer;
